import { Card, CardContent, Chip, Grid, Typography } from "@mui/material"

export const Graphics = ({
    elementoActivo,
    parametroActivo,
    ChartContainer,
    elementoGeneralSeleccionado
}) => {
    return (
        <>
            <Card style={{ height: "600px", overflowY: "auto" }}>
                <CardContent sx={{ p: 2 }}>
                    {elementoActivo.nombre ? (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <h4 style={{ marginLeft: "10px", fontSize: "1.25rem" }}>
                                    {elementoActivo.nombre}
                                </h4>
                            </Grid>
                            {/* Contingut del grid Gràfics */}
                            <Grid item xs={12}>
                                <Card style={{ height: "600px", overflowY: "auto" }}>
                                    <CardContent sx={{ p: 2 }}>
                                        <Grid
                                            container
                                            spacing={6}
                                            sx={{ mb: 2, justifyContent: "space-between" }}
                                        >
                                            {parametroActivo.nombre ? (
                                                <>
                                                    <Grid item>
                                                        <Typography variant="h6">
                                                            Vista gráfica del parámetro
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Chip
                                                            label={parametroActivo.nombre}
                                                            color="primary"
                                                        />
                                                    </Grid>
                                                </>
                                            ) : (
                                                <Grid item>
                                                    <Typography variant="h6">
                                                        Selecciona un parámetro de la tabla
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>

                                        <ChartContainer />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    ) : (
                        elementoGeneralSeleccionado !== undefined && (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <h4 style={{ marginLeft: "10px", fontSize: "1.25rem" }}>
                                        {elementoGeneralSeleccionado.descripcion !== null
                                            ? elementoGeneralSeleccionado.nombre +
                                            " " +
                                            elementoGeneralSeleccionado.descripcion
                                            : elementoGeneralSeleccionado.nombre +
                                            " " +
                                            elementoGeneralSeleccionado.numero}
                                    </h4>
                                </Grid>
                                {/* Contingut del grid Gràfics */}
                                <Grid item xs={12}>
                                    <Card
                                        style={{ height: "600px", overflowY: "auto" }}
                                    >
                                        <CardContent sx={{ p: 2 }}>
                                            <Grid
                                                container
                                                spacing={6}
                                                sx={{
                                                    mb: 2,
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                {parametroActivo.nombre ? (
                                                    <>
                                                        <Grid item>
                                                            <Typography variant="h6">
                                                                Vista gráfica del parámetro
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Chip
                                                                label={parametroActivo.nombre}
                                                                color="primary"
                                                            />
                                                        </Grid>
                                                    </>
                                                ) : (
                                                    <Grid item>
                                                        <Typography variant="h6">
                                                            Selecciona un parámetro de la tabla
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </Grid>

                                            <ChartContainer />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        )
                    )}
                </CardContent>
            </Card>
        </>
    )
}